import { FormattedMessage, useIntl } from "react-intl";
import Toast from "../../../../common/core-ui/Toast.tsx";

export default function LaunchErrorToast({
  onClose,
}: {
  onClose?: () => void;
}) {
  const intl = useIntl();
  return (
    <Toast
      onClose={onClose}
      type="error"
      title={intl.formatMessage({
        defaultMessage: "Content Access Error",
      })}
    >
      <FormattedMessage defaultMessage="This material cannot be accessed. Please contact support." />
    </Toast>
  );
}
